<template>
    <div class="row">
        <div class="col-12">
            <table class="table">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Zone</th>
                        <th>Function</th>
                        <th>Type</th>
                        <th>Description on Panel</th>
                        <th>Group</th>
                        <th class="text-center">
                            Tamper Tested
                        </th>
                        <th>Tested</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <draggable
                    v-model="testItems"
                    tag="tbody"
                    handle=".drag-handle"
                >
                    <tr
                        v-for="(item, index) in testItems"
                        :key="'test_item_' + index"
                    >
                        <td class="drag-handle-col">
                            <span class="drag-handle">
                                <i class="fas fa-arrows-alt-v" />
                            </span>
                        </td>
                        <td v-if="item.type === 'item' || !item.type">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Zone"
                                v-model="item.zone"
                            >
                        </td>
                        <td v-if="item.type === 'item' || !item.type">
                            <select
                                v-model="item.function"
                                class="form-control"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select Function..
                                </option>
                                <option>Intruder</option>
                                <option>Final</option>
                                <option>Exit</option>
                                <option>24 Hours</option>
                                <option>Spare</option>
                                <option>Line Fault</option>
                                <option>Fire Alarm</option>
                                <option>Panic Button</option>
                                <option>Sensor</option>
                                <option>Text</option>
                            </select>
                            <input
                                type="text"
                                v-show="item.function === 'Text'"
                                v-model="item.function_text"
                                placeholder="Type function..."
                                class="form-control"
                            >
                        </td>
                        <td v-if="item.type === 'item' || !item.type">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Type"
                                v-model="item.type_text"
                            >
                        </td>
                        <td v-if="item.type === 'item' || !item.type">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Description on Panel"
                                v-model="item.description"
                            >
                        </td>
                        <td v-if="item.type === 'item' || !item.type">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Group"
                                v-model="item.group"
                            >
                        </td>
                        <td
                            class="text-center"
                            v-if="item.type === 'item' || !item.type"
                        >
                            <input
                                type="checkbox"
                                class="form-control large-checkbox"
                                placeholder="Tamper"
                                v-model="item.tamper"
                                :disabled="hideTesting"
                            >
                        </td>
                        <td v-if="item.type === 'item' || !item.type">
                            <input
                                type="checkbox"
                                class="form-control large-checkbox"
                                v-model="item.tested"
                                :disabled="hideTesting"
                            >
                        </td>
                        <td v-if="item.type === 'rio'">
                            Rio Location:
                        </td>
                        <td
                            v-if="item.type === 'rio'"
                            colspan="6"
                        >
                            <input
                                type="text"
                                placeholder="Location..."
                                class="form-control"
                                v-model="item.rio_location"
                            >
                        </td>
                        <td v-if="item.type === 'battery'">
                            Battery Size (AMP):
                        </td>
                        <td v-if="item.type === 'battery'">
                            <input
                                type="number"
                                v-model="item.size"
                                min="0"
                                step="0.01"
                                class="form-control"
                                placeholder="Size (AMP)"
                            >
                        </td>
                        <td v-if="item.type === 'battery'">
                            Battery Volts:
                        </td>
                        <td v-if="item.type === 'battery'">
                            <input
                                type="number"
                                v-model="item.volts"
                                min="0"
                                step="0.01"
                                class="form-control"
                                placeholder="Battery Volts"
                            >
                        </td>
                        <td v-if="item.type === 'battery'">
                            Battery Amps:
                        </td>
                        <td v-if="item.type === 'battery'">
                            <input
                                type="number"
                                v-model="item.amps"
                                min="0"
                                step="0.01"
                                class="form-control"
                                placeholder="Battery Amps"
                            >
                        </td>
                        <td
                            colspan="2"
                            class="text-right"
                        >
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                @click.prevent="removeTestItem(index)"
                            >
                                <i class="fa fa-times" />
                            </button>
                        </td>
                    </tr>
                </draggable>
                <tfoot>
                    <tr>
                        <td colspan="8">
                            <button
                                class="btn btn-secondary"
                                @click.prevent="addTestItem"
                            >
                                Add Test Line
                            </button>
                            <button
                                class="btn btn-secondary"
                                @click.prevent="addRio"
                            >
                                Add Rio
                            </button>
                            <button
                                class="btn btn-secondary"
                                @click.prevent="addPowerRio"
                            >
                                Add Power Rio
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
    components: {
        draggable,
    },
    props: {
        value: {
            type: Array,
            required: false,
            default: () => [],
        },
        hideTesting: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            testItems: [],
            loading: false,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.loading = true;
                this.testItems = this.value ? this.value.slice(0) : [];
                window.setTimeout(() => {
                    this.loading = false;
                }, 500);
            },
        },
        testItems: {
            immediate: false,
            handler() {
                if (!this.loading) {
                    this.$emit("input", this.testItems);
                }
            },
        },
    },
    methods: {
        removeTestItem(index) {
            this.testItems.splice(index, 1);
            this.$forceUpdate();
        },

        addTestItem() {
            this.testItems.push({
                type: "item",
                function: null,
                tested: "No",
            });
            this.$forceUpdate();
        },

        addRio() {
            this.testItems.push({
                type: "rio",
                location: "",
            });
            this.$forceUpdate();
        },
        addPowerRio() {
            this.addRio();
            this.testItems.push({
                type: "battery",
            });
            this.$forceUpdate();
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/IntruderAlarmZones.vue